/* Innate blog index — staggered reveal (2026-08-09)

   Fades each card up as it enters the viewport. Styling is in innate-blog.css.

   SEO: the hide-then-reveal class is added here, at runtime, rather than
   sitting in the stylesheet. If this script does not run — a crawler that
   skips JS, a blocked asset, an old browser — no card is ever transparent or
   offset, and the page renders complete. Hiding in CSS and revealing in JS
   would be the usual shortcut, and it is exactly the pattern that risks
   content being treated as hidden.

   The same reasoning covers reduced motion: the reveal is skipped entirely
   rather than run instantly, so nothing flickers. */

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    if (!document.body.classList.contains('template-blog')) return;

    var list = document.querySelector('.excerpts');
    if (!list) return;

    var posts = [].slice.call(list.querySelectorAll('.post'));
    if (!posts.length) return;

    // No observer, or the reader does not want motion: leave the page as the
    // markup renders it.
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    list.classList.add('is-blog-reveal');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var post = entry.target;
        var delay = parseInt(post.dataset.revealIndex || '0', 10) * 70;
        window.setTimeout(function () { post.classList.add('is-in'); }, delay);
        observer.unobserve(post);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    posts.forEach(function (post, i) {
      // Stagger only within a row of three, so a card low on the page does not
      // inherit a long delay from its position in the whole list.
      post.dataset.revealIndex = String(i % 3);
      observer.observe(post);
    });

    // Anything already on screen at load should not wait for a scroll that may
    // never come — on a short list the observer would otherwise leave the last
    // cards hidden.
    window.setTimeout(function () {
      posts.forEach(function (post) {
        var top = post.getBoundingClientRect().top;
        if (top < window.innerHeight) post.classList.add('is-in');
      });
    }, 60);
  });
})();

/* Sort control (2026-08-10)

   Reorders the cards already on the page. It cannot sort the whole blog:
   Shopify's Liquid exposes no query parameters, so the chosen sort is
   unreadable server-side, and paginate has already sliced the list by the time
   this runs. The button says "Sort this page" for that reason.

   Topic filtering is handled by plain links to Shopify's /tagged/ routes, so
   that half is server-side, covers every article and stays crawlable.

   Sorting reads what is already rendered — the DOM arrives newest-first, so
   "most recent" is the original order and "oldest" is its reverse. No dates are
   parsed: the theme prints them in a display format, not ISO, and parsing that
   would be guesswork. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    if (!document.body.classList.contains('template-blog')) return;

    var wrap = document.querySelector('[data-blog-filter]');
    var list = document.querySelector('.excerpts');
    if (!wrap || !list) return;

    var posts = [].slice.call(list.querySelectorAll('.post'));
    if (posts.length < 2) return;

    var original = posts.slice();
    var label = wrap.querySelector('[data-blog-filter-label]');
    var buttons = [].slice.call(wrap.querySelectorAll('[data-blog-sort]'));

    function titleOf(post) {
      var h = post.querySelector('h2');
      return (h ? h.textContent : '').trim().toLowerCase();
    }

    function apply(mode, text) {
      var order = original.slice();
      if (mode === 'oldest') order.reverse();
      if (mode === 'az') order.sort(function (a, b) { return titleOf(a).localeCompare(titleOf(b)); });

      order.forEach(function (post) { list.appendChild(post); });

      // The lead treatment follows the sort — whichever article lands first
      // becomes the featured card. Nothing to do here: the styling hangs off
      // :first-child, so moving the nodes moves the treatment with them.

      buttons.forEach(function (b) {
        var on = b.dataset.blogSort === mode;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      if (label) label.textContent = text;
      wrap.open = false;
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        apply(btn.dataset.blogSort, btn.textContent.trim());
      });
    });

    document.addEventListener('click', function (event) {
      if (wrap.open && !wrap.contains(event.target)) wrap.open = false;
    });

    wrap.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && wrap.open) {
        wrap.open = false;
        wrap.querySelector('summary').focus();
      }
    });
  });
})();
